module.exports = __webpack_public_path__ + "static/3-9191921b53aa0ac555701b16ee862dc5.jpg";